
  <!-- Modal Header -->
  <ng-container *ngIf="BOMPRoductList; else loading">
    <div class="cx-modal-container">
      <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ "addCart.bomProductsAdded" | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismissModal('Cross click')"
      >
        <span aria-hidden="true">
          <i class="material-icons">close</i>
        </span>
      </button>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body add-to-cart-modal" >
      <div class="cx-dialog-row row">
        <div class="cx-dialog-item col-md-6">
         {{BOMPRoductList.length}} {{ "addCart.productsAdded" | cxTranslate }}
        </div>
        <div class="cx-dialog-actions col-sm-12 col-md-6">
          <div class="cx-dialog-total" *ngIf="cart$ | async as cart">
          </div>
          <div class="cx-dialog-buttons">
            <button
              class="vs-primary-btn"
              autofocus
              (click)="dismissModal('View Cart click')"
              >{{ "addCart.continueShoppingBtn" | cxTranslate }}</button
            >
            <button
              [class.disabled]="form.dirty"
              [routerLink]="{ cxRoute: 'cart' } | cxUrl"
              class="vs-tertiary-btn"
              (click)="!form.dirty && dismissModal('Proceed To Checkout click')"
              >{{ "addCart.viewShoppingCartBtn" | cxTranslate }}</button
            >
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ 'addCart.updatingCart' | cxTranslate }}
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismissModal('Cross click')"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row">
        <div class="col-sm-12"><cx-spinner></cx-spinner></div>
      </div>
    </div>
    </div>
    </div>
  </ng-template>

